import { timerActions } from "../../../store/timerSlice";
import { UrlConstant } from "../../../urlConstant/UrlConstant";
import { useHttpRequest } from "../../../utils";
import useCallBack, { Callbacks } from "../../../utils/callback/useCallBack";


export const GetDocumentByResourceIdMutation = <T>(
  id:string,
  callbacks?: Callbacks<T>
) => {
  const { onError, onLoading, onSuccess } = useCallBack<any>(callbacks);

  const { getRequest } = useHttpRequest({});
  return async (dispatch: any) => {
    const getDocuments = async () => {
      try {
        const response = await getRequest(
          `${UrlConstant.DocumentV1}/${UrlConstant.GetByResourceId}?id=${id}`
        );
        const data = await response;
        return data;
      } catch (error) {
        onError(error as Error);
      }
    };
    try {
      const res = await getDocuments();
      if (res) {
        if (res?.succeeded) {
          const response = res?.data ?? [];
          if (response && Array.isArray(response)) {
            dispatch(timerActions.getDocuments(response));
            onSuccess(response);
          } 
        }
      }
    } catch (error) {
      onError(error as Error);
    } finally {
      onLoading(false);
    }
  };
};
